import { render } from "./ImageUpload.vue?vue&type=template&id=24044561&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import "./ImageUpload.vue?vue&type=style&index=0&id=24044561&scoped=true&lang=css"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24044561"]])

export default __exports__